<template>
  <div class="flex flex-col min-h-screen">
    <SiteHeader :page-name="'Access Denied'" />
    <div class="w-full my-auto text-center pb-12">
      <div class="bg-surface-400 dark:bg-surface-600 rounded-full p-12 w-[600px] h-[600px] mx-auto flex flex-col justify-center drop-shadow-bevel">
        <p class="text-5xl font-extrabold text-surface-300 dark:text-surface-700 drop-shadow-bevel">ERROR 401</p>
        <i class="pi pi-exclamation-triangle me-2 text-[20rem] font-bold text-surface-300 dark:text-surface-700 drop-shadow-bevel"></i>
        <p class="text-5xl font-extrabold text-surface-300 dark:text-surface-700 drop-shadow-bevel">UNAUTHORIZED</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
